import { ProductCategoriesView } from '@today/ui-domain'
import { useProductCategories } from '@/hooks/products/useProductCategories'

/** `/product-categories` — category management (TO-416 product-admin-ui REQ-008). */
export function ProductCategoriesPage() {
	return <ProductCategoriesView {...useProductCategories()} />
}
